import React from 'react';

export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-util@4.5.1@rc-util/es/Children/toArray.js
// module id = null
// module chunks = 